export default "__VITE_ASSET__BHdLlV78__"